// Pure client-side inference — no schema change. An SOP is flagged "Draft"
// if its version string or body indicates incomplete content. The backend
// enforces the same rule in routes/sops._is_sop_draft for assignment guards
// and compliance maths.
export function isSOPDraft(sop) {
  if (!sop) return false;
  const v = (sop.version || '').toLowerCase();
  if (v.includes('tba') || v.includes('draft v0') || v.includes('— index') || v.includes('pending')) return true;
  const c = (sop.content || '').toLowerCase();
  if (c.includes('## status') && (c.includes('to be developed') || c.includes('tba'))) return true;
  return false;
}
